import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=c11ebfc0"
import script from "./Loads.vue?vue&type=script&lang=js"
export * from "./Loads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports